import classes from "./footer.module.css";

function Footer() {
  return (
    <div className={classes.Footer}>
      <p className={classes.copyRightText}>
        Copyright © {new Date().getFullYear()} スカイセブンモバイル All Rights
        Reserved.
      </p>
    </div>
  );
}

export default Footer;
